module.exports = __webpack_public_path__ + "static/media/trigonometryProblem1.14866cbd.svg";